// Add your custom JS here.

var pagetop;
var scrollButtonShow = false;
var inquiryButton;
document.addEventListener("DOMContentLoaded", function (event) {
    pagetop = document.getElementById("pagetopbutton");
    pagetop.style.opacity = 0;
    inquiryButton = document.getElementById('inquiry-button-wrapper');
    window.onscroll = function () { scrollFunction() };
    pagetop.addEventListener('click', function() {
        window.scroll({ top: 0, behavior: "smooth" });
    });
    
    var offcanvasNavbar = document.getElementById('offcanvasNavbar');
    var menuButton = document.getElementById('navbar-toggler-button');
    offcanvasNavbar.addEventListener('show.bs.offcanvas', event => {
        menuButton.classList.add("open");
    });
    offcanvasNavbar.addEventListener('hide.bs.offcanvas', event => {
        menuButton.classList.remove("open");
    });

});

function scrollFunction() {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        if (scrollButtonShow == false) {
            pagetop.classList.remove("d-none");
            pagetop.classList.add("d-block");
            inquiryButton.classList.remove("d-none");
            inquiryButton.classList.add("d-flex");

            var anm = pagetop.animate(
                [{ opacity: 1 }],
                {
                    duration: 100,
                    easing: 'linear'
                }
            );
            anm.onfinish = (e) => {
                pagetop.style.opacity = 1;
            };
            var anm2 = inquiryButton.animate(
                [{ opacity: 1 }],
                {
                    duration: 100,
                    easing: 'linear'
                }
            );
            anm2.onfinish = (e) => {
                inquiryButton.style.opacity = 1;
            };
            scrollButtonShow = true;
        }
    } else {
        if (scrollButtonShow == true) {
            var anm = pagetop.animate(
                [{ opacity: 0 }],
                {
                    duration: 100,
                    easing: 'linear'
                }
            );
            anm.onfinish = (e) => {
                pagetop.style.opacity = 0;
                pagetop.classList.remove("d-block");
                pagetop.classList.add("d-none");
            };
            var anm2 = inquiryButton.animate(
                [{ opacity: 0 }],
                {
                    duration: 100,
                    easing: 'linear'
                }
            );
            anm2.onfinish = (e) => {
                inquiryButton.style.opacity = 0;
                inquiryButton.classList.remove("d-flex");
                inquiryButton.classList.add("d-none");
            };

            scrollButtonShow = false;
        }
    }
}
AOS.init();